module.exports = __webpack_public_path__ + "I2U1-exblack.png?fb3f37ca905f577a5002ae5f599999d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/I2U1-exblack.png
// module id = 93
// module chunks = 0